const calcColor = (cbFriendly, isReversed, isInAttrNames, trend, min, max) => {
  let color = null;

  if (isReversed) {
    // Reverses color scheme for when higher numbers mean more cold
    if(trend > 0) {
      color = `hsla(210, 100%, ${90 - trend / max * 65}%, 0.95)`;
    } else if (trend < 0) {
      color = `hsla(0, 100%, ${90 - trend / min * 65}%, 0.95)`;
    } else {
      color = 'hsla(0, 100%, 100%, 0.95)';
    }
  } else {
    if(trend > 0) {
      if(isInAttrNames) {
        color = `hsla(0, 100%, ${90 - trend / max * 65}%, 0.95)`;
      } else {
        color = cbFriendly ? `hsla(103, 63.8%, ${100 - trend / max * 58.8}%, 0.95)` : `hsla(135, 100%, ${75 - trend / max * 75}%, 0.95)`;
      }
    } else if (trend < 0) {
      if(isInAttrNames) {
        color = `hsla(210, 100%, ${90 - trend / min * 65}%, 0.95)`;
      } else {
        color = cbFriendly ? `hsla(323, 76.3%, ${100 - trend / min * 53.6}%, 0.95)` : `hsla(40, 100%, ${75 - trend / min * 75}%, 0.95)`;
      }
    } else {
      color = 'hsla(0, 100%, 100%, 0.95)';
    }
  }

  return color;
};


const getMapColorRange = (state, county, isClimate) => {
  if (!state || ! county) {
    return {
      state: {
        min: 0,
        max: 0
      },
      county: {
        min: 0,
        max: 0
      }
    };
  }

  state = Object.values(state);
  county = Object.values(county);
  
  let countyMax = Math.max(...county);
  let countyMin = Math.min(...county);
  let stateMax = Math.max(...state);
  let stateMin = Math.min(...state);

  if (isClimate) {
    stateMax = Math.max(Math.abs(stateMax), Math.abs(stateMin)).toFixed(2);
    stateMin = -stateMax;
    countyMax = Math.max(Math.abs(countyMax), Math.abs(countyMin)).toFixed(2);
    countyMin = -countyMax;
  } else {
    stateMax = Math.ceil(stateMax/10)*10;
    stateMin = 0;
    countyMax = Math.ceil(countyMax/10)*10;
    countyMin = 0;
  }
  
  return {
    state: {
      min: stateMin,
      max: stateMax
    },
    county: {
      min: countyMin,
      max: countyMax
    }
  };

  // let max = Math.max(...county, ...state);
  // let min = Math.min(...county, ...state);

  // if (isClimate) {
  //   max = Math.max(Math.abs(max), Math.abs(min)).toFixed(2);
  //   min = -max;
  // } else {
  //   max = Math.ceil(max/10)*10;
  //   min = 0;
  // }
  
  // return { max, min };
};


const generateClimateExpressions = (cbFriendly, data, isReversed, isInAttrNames, min, max, isState) => {
  let expArr = isState ? ['match', ['get', 'STUSPS']] : ['match', ['get', 'GEOID']];

  if (data) {
    Object.entries(data).forEach(([location, trend]) => {
      expArr.push(location, calcColor(cbFriendly, isReversed, isInAttrNames, trend, min, max));
    });
  }

  expArr.push('rgba(0,0,0,0)');
  return expArr;
};

const getClimateColors = (cbFriendly, stateTrends, countyTrends, isInAttrNames, isReversed) => {
  const range = getMapColorRange(stateTrends, countyTrends, true);
  const stateExpression = generateClimateExpressions(cbFriendly, stateTrends, isReversed, isInAttrNames, range.state.min, range.state.max, true);
  const countyExpression = generateClimateExpressions(cbFriendly, countyTrends, isReversed, isInAttrNames, range.county.min, range.county.max, false);
  // const stateExpression = generateClimateExpressions(cbFriendly, stateTrends, isReversed, isInAttrNames, range.min, range.max, true);
  // const countyExpression = generateClimateExpressions(cbFriendly, countyTrends, isReversed, isInAttrNames, range.min, range.max, false);

  return {
    newMCR: range,
    newSC: stateExpression,
    newCC: countyExpression
  };
};


const pickColor = (value) => {
  let h,s,l;
  if (value === 0) {
    [h,s,l] = [40, 0, 50];
  } else if (value < 1000) {
    [h,s,l] = [37.85, 80.25, 84.12];
  } else if (value < 10000) {
    [h,s,l] = [39.13, 86.47, 73.92];
  } else if (value < 100000) {
    [h,s,l] = [39.3, 92.43, 63.73];
  } else if (value < 1000000) {
    [h,s,l] = [39.83, 99.16, 53.53];
  } else if (value < 10000000) {
    [h,s,l] = [30, 100, 50];
  } else if (value < 100000000) {
    [h,s,l] = [20, 100, 50];
  } else if (value < 1000000000) {
    [h,s,l] = [10, 100, 50];
  } else {
    [h,s,l] = [0, 100, 50];
  }

  return `hsla(${h}, ${s}%, ${l}%, 0.95)`;
};


const generateHazardExpressions = (data, isState, isDamage, max) => {
  let expArr = isState ? ['match', ['get', 'STUSPS']] : ['match', ['get', 'GEOID']];
  
  if (data) {
    if (isDamage) {
      Object.entries(data).forEach(([location, value]) => {
        expArr.push(location, pickColor(value));
      });
    } else {
      Object.entries(data).forEach(([location, value]) => {
        let color = (max === 0) ? 'hsla(40,0%,50%,0.95)' : `hsla(40, ${value / max * 100}%, 50%, 0.95)`;
        expArr.push(location, color);
      });
    }
  }

  expArr.push('hsla(40,0%,50%,0.95)');
  return expArr;
};


const getHazardColors = (stateData, countyData, isDamage) => {
  const range = getMapColorRange(stateData, countyData, false);
  // const stateExpression = generateHazardExpressions(stateData, true, isDamage, range.max);
  // const countyExpression = generateHazardExpressions(countyData, false, isDamage, range.max);
  const stateExpression = generateHazardExpressions(stateData, true, isDamage, range.state.max);
  const countyExpression = generateHazardExpressions(countyData, false, isDamage, range.county.max);

  return {
    newMCR: range,
    newSC: stateExpression,
    newCC: countyExpression
  };
};



export default function getNewColors(cbFriendly, isClimate, stateData, countyData, climateOption, attributeOptions, hazard) {
  if (stateData && countyData) {
    if (isClimate) {
      const attrNameList = Object.keys(attributeOptions).filter(attrName => attributeOptions[attrName].precip === false);
      const isInAttrNames = attrNameList.includes(climateOption);
      const isReversed = climateOption.includes('cntlt');
      
      return getClimateColors(cbFriendly, stateData[climateOption], countyData[climateOption], isInAttrNames, isReversed);
    } else {
      const countyMapData = countyData[hazard] || {'undefined': 0};
      const stateMapData = stateData[hazard] || {
        DC: 0,
        DE: 0,
        IL: 0,
        IN: 0,
        MD: 0,
        MI: 0,
        MN: 0,
        NC: 0,
        NJ: 0,
        NY: 0,
        OH: 0,
        PA: 0,
        SC: 0,
        VA: 0,
        WI: 0,
        WV: 0
      };
      
      return getHazardColors(stateMapData, countyMapData, hazard.includes('damage'));
    }
  }
}